
<div class="language-picker--language language-picker--selected" (click)="isActive = !isActive">
  <img [ngSrc]="'/assets/i18n/flags/' + locale + '.svg'" height="20" width="10" alt="Flag">
  <div class="language-picker--label" i18n>
    {{ locales[locale] }}
  </div>
</div>

<div class="language-picker--popup">
  @for (locale of Object.entries(locales); track locale[0]) {
    <a [href]="'/' + locale[0] + '/' + path" class="language-picker--language e--link-plain" (click)="select(locale[0])">
      <img [ngSrc]="'/assets/i18n/flags/' + locale[0] + '.svg'" height="20" width="10" alt="Deutsch">
      <div class="language-picker--label" i18n>
        {{ locale[1] }}
      </div>
    </a>
  }
</div>
